export function loadScript(
  src: string,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onload: any,
  parentElement?: HTMLHeadElement
): void {
  // get document if platform is only browser
  if (typeof document !== 'undefined') {
    const signInJS = document.createElement('script');

    signInJS.async = true;
    signInJS.src = src;
    signInJS.onload = onload;

    if (!parentElement) {
      parentElement = document.head;
    }

    parentElement.appendChild(signInJS);
  }
}
